import styled from 'styled-components'
import { Flex } from 'ui/acro'
import React from 'react'
import { verify_account_initiated_event } from 'gtm/pushEvents'
import { Text } from 'ui/bend'
import InfoTooltip from 'components_v2/Membership/Edit/InfoToolTip'

const VerifySection = styled(Flex)(({ isSettingsPage }) => ({
  flexDirection: 'column',
  gap: '8px',
  alignItems: isSettingsPage ? 'flex-start' : 'center'
}))

const Title = styled(Text)({
  color: '#000',
  fontFamily: 'Proxima-Nova',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  letterSpacing: '0.352px'
})

const Link = styled('a')(({ isSettingsPage }) => ({
  color: '#000',
  fontFamily: 'Proxima-Nova',
  fontSize: '14px',
  fontWeight: isSettingsPage ? 600 : 400,
  lineHeight: '18px',
  letterSpacing: '0.308px',
  textDecoration: 'underline !important',
  '&:visited': {
    color: '#000',
    textDecoration: 'underline !important'
  },
  '&:focus': {
    color: '#000',
    textDecoration: 'underline !important'
  }
}))

const AloVerifySection = ({ isSettingsPage = false, verifyLink, event }) => {
  if (window.location.pathname === '/verify-alo') return null
  return (
    <VerifySection isSettingsPage={isSettingsPage}>
      <Title>
        {isSettingsPage && (
          <>
            {' '}
            <b>Already </b> an ALO Access loyalty member through aloyoga.com?{' '}
          </>
        )}
      </Title>
      {isSettingsPage && (
        <Flex gap={'2px'} alignItems={'center'}>
          <Link
            isSettingsPage={isSettingsPage}
            href={verifyLink}
            onClick={() => verify_account_initiated_event(event)}
          >
            {'Link Existing Account'}
          </Link>
          {event !== 'sign_up' && (
            <InfoTooltip
              style={{ marginLeft: '2px' }}
              text={
                <>
                  {
                    'Use your aloyoga.com credentials to link your accounts and sync your ALO Access status & points.'
                  }
                </>
              }
            />
          )}
        </Flex>
      )}
    </VerifySection>
  )
}

export default AloVerifySection
